var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 21 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#clock_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.365.567a1.07 1.07 0 0 1-.443 1.45 11.3 11.3 0 0 0-3.263 2.61A1.071 1.071 0 0 1 1.036 3.23 13.5 13.5 0 0 1 4.915.126a1.07 1.07 0 0 1 1.45.441Zm8.823 0a1.07 1.07 0 0 1 1.45-.441 13.5 13.5 0 0 1 3.878 3.104 1.071 1.071 0 0 1-1.623 1.397 11.3 11.3 0 0 0-3.264-2.61 1.07 1.07 0 0 1-.441-1.45ZM2.857 14.709a8.571 8.571 0 1 1 15.838-6.56 8.571 8.571 0 0 1-15.838 6.56Zm8.812-7.566a.893.893 0 0 0-1.785 0v4.286c0 .492.4.892.893.892h3.571a.892.892 0 1 0 0-1.785H11.67z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.776 0h20v20h-20z"
  })))));
};
export default SvgClock;